import { Link } from "react-router-dom";

interface SectionTitleProps {
  icon: string;
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionTitle({ icon, title, subtitle, moreTo, moreLabel }: SectionTitleProps) {
  return (
    <div className="flex items-end justify-between mb-5 md:mb-6 gap-4">
      <div className="flex items-center gap-3">
        <span className="w-9 h-9 shrink-0 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
          <i className={`${icon} text-lg`}></i>
        </span>
        <div>
          <h2 className="text-lg md:text-xl font-bold text-foreground-950 font-heading">{title}</h2>
          {subtitle && <p className="mt-0.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>}
        </div>
      </div>
      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 text-sm text-primary-600 hover:text-accent-600 transition-colors flex items-center gap-1 whitespace-nowrap cursor-pointer"
        >
          {moreLabel ?? "查看更多"}
          <i className="ri-arrow-right-s-line"></i>
        </Link>
      )}
    </div>
  );
}